import { Divider } from 'primereact/divider';
import { Skeleton } from 'primereact/skeleton';
import { ReactNode } from 'react';

type DetailRowProps = {
  label: ReactNode;
  isLoading?: boolean;
  showDivider?: boolean;
  labelClassName?: string;
  children: ReactNode;
};

const DetailRow = ({
  label,
  isLoading = false,
  showDivider = true,
  labelClassName = 'font-medium',
  children,
}: DetailRowProps): JSX.Element => {
  return (
    <>
      <div className='flex flex-row justify-content-between align-items-center gap-4 py-3'>
        <span className={labelClassName}>{label}</span>
        <div className='flex flex-column align-items-end text-right'>
          {isLoading ? <Skeleton width='120px' height='16px' /> : children}
        </div>
      </div>
      {showDivider && <Divider className='m-0' />}
    </>
  );
};

export default DetailRow;
